import axios from "axios";

const uri = 'https://www.lefisc.com.br/api/apiDIFAL/calcular/difal'

const tok = "bd329d7b833e98162cffa558f9389759";

export default{
    postForm(objeto){
        return axios
            .post(`${uri}/${tok}`, objeto)
            .then(res => {
                console.log('enviado com sucesso!');
                return res;
            }, err => {
                throw new Error (console.error(err));
        });
    },
 
    postFormAcre(anexo,objeto){        
        return axios
            .post(`${uri}/acre/${anexo}/`, objeto)
            .then(res => {
                console.log('enviado com sucesso!');
                return res;
            }, err => {
                throw new Error (console.error(err));
        });
    }
} 



// WEBPACK FOOTER //
// ./src/services/serviceAliquotas.js